module.exports = __webpack_public_path__ + "img/MTL.d9055573.svg";